import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantService } from 'src/app/core/services/api/tenant.service';
import { TenantLocalService } from 'src/app/core/services/api/tenantlocal.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { SocialAuthStateService } from 'src/app/core/services/auth/social-auth-state.service';
import { Swal2 } from 'src/app/core/utils/swal2.util';

@Component({
  selector: 'app-register-loading-modal',
  templateUrl: './register-loading-modal.component.html',
  styleUrl: './register-loading-modal.component.scss'
})
export class RegisterLoadingModalComponent {
  isSuccess = false;
  currentMessage = "Preparando tu espacio de trabajo...";
  loadingMessages = [
    "Preparando tu espacio de trabajo...",
    "Registrando tus datos...",
    "Creando tu cuenta de Agente de Prensa...",
    "Esto tomará solo unos segundos..."
  ];
  private intervalId: any;
  loading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<RegisterLoadingModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auth: AuthService,
    private tenantService: TenantService,
    private tenantlocalservice: TenantLocalService,
    private swal: Swal2,
    private router: Router,
    private socialAuthState: SocialAuthStateService
  ) {
    this.startMessageRotation();
  }

  startMessageRotation() {
    let index = 0;
    this.intervalId = setInterval(() => {
      if (this.isSuccess) return;
      index = (index + 1) % this.loadingMessages.length;
      this.currentMessage = this.loadingMessages[index];
    }, 2500);
  }

  showSuccess() {
    this.isSuccess = true;
    clearInterval(this.intervalId);
  }

  close() {
    this.dialogRef.close(true);

    // Si el usuario tiene datos de red social guardados, hacemos auto login social
    const socialUser = this.socialAuthState.getUser();

    if (socialUser) {
      this.autoLoginSocial(socialUser.provider);
    } else if (this.data?.email && this.data?.password) {
      this.autoLogin(this.data.email, this.data.password);
    } else {
      this.swal.showToast("No se encontraron credenciales para iniciar sesión.", "warning");
    }
  }

  // Register normal
  private autoLogin(email: string, password: string) {
    this.loading = true;
    this.auth.login({ email, password }).subscribe({
      next: (response: any) => {
        this.handleTenantLogin(response);
      },
      error: (err) => {
        this.swal.showToast("Error al iniciar sesión automáticamente.", "error");
        this.loading = false;
      }
    });
  }

  // Register social automático
  private autoLoginSocial(provider: string) {
    this.loading = true;

    this.auth.loginWithProvider(provider as 'google' | 'linkedin')
      .then(({ user, is_new }) => {

        if (!is_new) {
          const tenants = user?.tenants || [];
          if (tenants.length === 1) {
            // console.log(tenants);
            
            const slug = tenants[0].slug;
            this.tenantlocalservice.setTenantSlug(slug);
            this.tenantService.setTenantInBackend(slug).subscribe({
              next: (res: any) => {
                this.tenantlocalservice.setTenant(res.tenant);
                this.auth.savePermisosRolesInLocalStorage(res);
                this.auth.redirectToDashboard();
              },
              error: (err) => {
                this.swal.showToast("Error iniciando sesión automáticamente.", "error");
              }
            });
          } else {
            this.swal.showToast("No se encontró empresa asignada al usuario.", "error");
          }
        } else {
          this.swal.showToast("El usuario fue detectado como nuevo, no debería pasar aquí.", "error");
        }

        this.loading = false;
      })
      .catch(err => {
        this.swal.showToast("Error en autenticación con red social.", "error");
        this.loading = false;
      });
  }

  // Método común 
  private handleTenantLogin(response: any) {
    const tenants = response?.data?.user?.tenants || [];
    if (tenants.length === 1) {
      const slug = tenants[0].slug;
      this.tenantlocalservice.setTenantSlug(slug);
      this.tenantService.setTenantInBackend(slug).subscribe({
        next: (res: any) => {
          this.tenantlocalservice.setTenant(res.tenant);
          this.auth.savePermisosRolesInLocalStorage(res);
          this.auth.redirectToDashboard();
        },
        error: (err) => {
          this.swal.showToast("Error iniciando sesión automáticamente.", "error");
        }
      });
    } else {
      this.swal.showToast("No se encontró empresa asignada al usuario.", "error");
    }
  }
}

